'use client';

import { EmblaCarouselType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';
import { Children, ComponentPropsWithoutRef, useContext, useEffect, useRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './mini-banner.scss';
import { MiniBannersContext } from './mini-banners-context';

type Props = ComponentPropsWithoutRef<'div'>;
export const MiniBannersCarousel = ({ children, ...props }: Props) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const { useStore } = useContext(MiniBannersContext);
    const isActive = useStore((s) => s.slidesInView.length !== Children.count(children));

    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: true,
        slidesToScroll: 1,
        direction: 'ltr',
        align: 'start',
        watchDrag: isActive,
        inViewThreshold: 0.9,
    });

    useEffect(() => {
        if (!emblaApi) return;
        const update = (emblaApi: EmblaCarouselType) => {
            useStore.setState({ slidesInView: emblaApi.slidesInView() });
        };
        emblaApi.on('slidesInView', update);
        update(emblaApi);
        return () => {
            emblaApi.off('slidesInView', update);
        };
    }, [emblaApi]);

    return (
        <div
            ref={emblaRef}
            className={cn('mini-banners', 'mini-banners--carousel')}
            data-active={isActive}
            {...props}
        >
            <div ref={containerRef} className="mini-banners--carousel__container">
                {children}
            </div>
        </div>
    );
};
